<template>
<!--此部分根据设计自动生成，手动修改节点标记daltag="manual"属性，则该节点及子节点不会被自动生成代码覆盖，如发现其他需要调整框架情形请联系:alex.c@daline.com.cn-->
<div id="dal-comp-project">
  <el-table id="bd2d964f" :data="tbd_bd2d964f" stripe="" border="">
    <el-table-column prop="a823550e" label="项目名称">
    </el-table-column>
    <el-table-column prop="a41c6972" label="客户名称">
    </el-table-column>
    <el-table-column prop="d25928de" label="产品经理">
    </el-table-column>
    <el-table-column prop="a79d3987" label="项目经理">
    </el-table-column>
    <el-table-column prop="ade4f88a" label="项目金额">
    </el-table-column>
    <el-table-column prop="b5e1c60d" label="设计开始时间">
    </el-table-column>
    <el-table-column prop="a9fe21ba" label="项目开始时间">
    </el-table-column>
    <el-table-column prop="b0b9773b" label="当前阶段">
    </el-table-column>
    <el-table-column prop="cc76fa4e" label="预交付时间">
    </el-table-column>
    <el-table-column prop="a64acc37" label="倒计时">
    </el-table-column>
  </el-table>
</div>
</template>
<script>
//此文件根据设计自动生成编写框架，请在指定位置编写逻辑代码，如发现框架需要调整的情形请联系:alex.c@daline.com.cn
//在此注释下方添加自定义import
//在此注释下方添加自定义函数
//此注释下方为自动引用部分，请不要修改
export default{
  data(){
    return{
    tbd_bd2d964f:[]
      //在此注释下方添加自定义变量
    }
  },
  mounted(){
  },
  computed:{
  },
  watch:{
  },
  methods:{
    //在此注释下方添加自定义函数或事件
  }
}
</script>
<style>
/*此部分根据设计自动生成，自定义样式追加到该部分结尾处*/
#bd2d964f{
  width:1323px;
  padding-bottom:0px;
}
#bd2d964f{
  display:inline-block;
  vertical-align: middle;
}
/*在此注释下方添加自定义样式*/
</style>
